import angular from 'angular';
import constants from 'app/constants';
import {
  riskDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './sync-risk-confirm-dialog.controller';
import template from './sync-risk-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    customerId, risk, riskType, isMultipleRisks, risks,
    updateCallBack,
  }) {
    return {
      controller,
      controllerAs: 'syncConfirmDialogVM',
      locals: {
        customerId,
        risk,
        riskType,
        risks,
        isMultipleRisks,
        updateCallBack,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.risk.syncRiskConfirmDialog', [
  alerts,
  riskDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('syncRiskConfirmDialog', dialogService)
  .name;
